import React from 'react';
import ReactDOM from 'react-dom/client';
import {App} from './app/App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {MessageBoxProvider} from './useMessageBox';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <MessageBoxProvider>
            <App />
        </MessageBoxProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
